import { ScenicDataInsights } from "@/store/types";

export const getScenicDataInsights = (data?: ScenicDataInsights) => {
  if(!Array.isArray(data)){
    console.warn('缺少scenic_data_insights数据',data);
    return null;
  }
  const xihuInsights = data?.find((item)=>item?.type === 'xihu_insights');
  if(xihuInsights){
    return xihuInsights;
  }else{
    console.warn('没有找到xihu_insights数据',data);
    return null;
  }
}

export const getScenicDataInsightsText = (data?: ScenicDataInsights) => {
  const xihuInsights = getScenicDataInsights(data);
  return xihuInsights?.text;
}

